( function ( _s ) {
	_s.fn.digitalExperienceHeader = function () {
		return this.el.forEach( header => {
			const _header = _s( header );
			const _arrows = _header.find( '.prev-next-arrow' );
			const _panelToggle = _header.find( '.panel-toggle' );
			const _viewedProjects = _header.find( '.viewed-projects' );
			let _digitalExperienceComponent = _s( '.digital-experience-component' );

			const initArrows = () => {
				_arrows.on( 'click keyup', e => {
					if (
						( e.type == 'keyup' && ( e.key === 'Enter' || e.keyCode === 13 ) ) ||
						e.type == 'click'
					) {
						const arrow = e.currentTarget;
						const _arrow = _s( arrow );
						const navDirection = _arrow.hasClass( 'next-project' ) ? 'next' : 'prev';

						_digitalExperienceComponent.trigger( 'custom-ev-next-prev-project', {
							navDirection: navDirection,
						} );
					}
				} );
			};

			const initPanelToggle = () => {
				_panelToggle.on( 'click keyup', e => {
					if (
						( e.type == 'keyup' && ( e.key === 'Enter' || e.keyCode === 13 ) ) ||
						e.type == 'click'
					) {
						const show = ! _panelToggle.hasClass( 'close' );

						_panelToggle.toggleClass( 'close', show );

						_digitalExperienceComponent.trigger( 'custom-ev-panel-toggle', {
							show: show,
						} );
					}
				} );
			};

			const init = () => {
				initArrows();
				initPanelToggle();
			};

			_header.on( 'custom-ev-viewprogress-update', e => {
				_viewedProjects.text( e.detail.viewed );
				header.style.setProperty( '--progress-width', `${ e.detail.viewProgress }%` );
			} );

			if ( _digitalExperienceComponent.length ) {
				init();
			} else {
				_header.on( 'custom-ev-map-loaded', () => {
					init();
				} );
			}
		} );
	};

	_s( document ).ready( () => {
		_s( '#digital-experience-header' ).digitalExperienceHeader();
	} );
} )( window._s );
